import React, {ChangeEvent, FocusEvent, Component, ReactNode} from 'react';
import {BetSlipStore} from 'app/store/BetSlipStore';
import BetSlipController from 'app/components/bet_slip/BetSlipController';
import {inject, observer} from 'mobx-react';
import {BetSlipFocus} from 'app/utils/Consts';
import AmountInput from 'app/components/reusable/AmountInput';
import {coefColorClass} from 'app/lines/coefColorClass';
import {isDesktop, mobileAndTabletCheck} from 'app/utils';

interface BetSlipInputAmountProps {
    betSlipStore?: BetSlipStore
    controller?: BetSlipController
}


@inject('betSlipStore', 'controller')
@observer
export default class BetSlipInputCoefContainer extends Component<BetSlipInputAmountProps> {
    inputAmount: React.RefObject<HTMLInputElement> = React.createRef();

    handleOnChange = (e: ChangeEvent<HTMLInputElement> | string): void => {
        this.props.controller.changeCoef(typeof e === 'string' ? e : e.target.value);
    };

    setFocus = (): void => this.inputAmount.current.focus();

    handelOnFocus = (e: FocusEvent<HTMLInputElement>): void => {
        const val = e.target.value;
        e.target.value = '';
        e.target.value = val;
        this.props.betSlipStore.setFocus(BetSlipFocus.COEF);
    };

    render(): ReactNode {
        const {betSlipStore: {formCoef, coefFocus}, controller: {checkAvailableAndMakeBet}} = this.props;
        const coefClass = coefFocus ? 'active' : '';
        const readOnly = !isDesktop() && mobileAndTabletCheck();

        return <AmountInput
            containerClassName="cell-inner-box"
            id="betSlipCoef"
            autoComplete="off"
            type="string"
            step="0.01"
            name="betSlipCoef"
            maxLength={8}
            className={`input-number${coefColorClass(null)} ${coefClass}`}
            autoFocus={false}
            placeholder="0.000"
            value={formCoef === null && !coefFocus ? '' : formCoef}
            onFocus={this.handelOnFocus}
            onChange={this.handleOnChange}
            readOnly={readOnly}
            inputRef={this.inputAmount}
            onEnterClick={checkAvailableAndMakeBet}
        />;
    }
}
